var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3804 1.82953C18.7448 -0.609846 22.2552 -0.609842 23.6196 1.82953L40.316 31.6808C41.6487 34.0634 39.9264 37 37.1965 37H3.80355C1.0736 37 -0.648648 34.0634 0.683984 31.6808L17.3804 1.82953Z",
    fill: "#FEA92A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8448,
    cy: 31.8204,
    r: 1.7266,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1183,
    y: 7.99316,
    width: 3.45321,
    height: 20.7192,
    rx: 1.7266,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.90a363f762c509ce8fd77559282ac588.svg";
export { ForwardRef as ReactComponent };